module.exports = __webpack_public_path__ + "media/images/redesign-images/promotions/promos-06_old-b07c4b74ce3e4e1d432d1d7a7ae6cbe3.jpg";